export const BALANCE_ADJUSTMENT_TYPE = 'BALANCE_ADJUSTMENT'
